var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const NonConsultantTitle = "View Members (ESIX Members, Administrators)";
export const InActiveConsultantTitle = "InActive Users";
export const MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
export const LOGGED_IN_USER = () => {
    const ROLE = localStorage.getItem("LoginRole");
    return ROLE ? ROLE.toLowerCase() : "";
};
export const SORT_KEYS = new Map([
    ["consultantName", "FirstName"],
    ["ratings", "Rating"],
    ["company", "CompanyName"],
    ["email", "Email"],
    ["country", "Country"],
    ["city", "City"],
    ["userType", "PersonTypeName"],
    ["updatedOn", 'UpdatedOn']
]);
//# sourceMappingURL=constants.js.map